import { Col, Form, Row, Modal, Button } from "react-bootstrap";

import styles from './Email.module.css';

const Email = props => {
  return (
    <>
      <Row className={styles.title}>
        Formulário para criação de e-mail corporativo
      </Row>
      <Row className="mt-4">
        <Col sm={4}>
          <Form.Group controlId="registration">
            <Form.Label>*Matrícula:</Form.Label>
            <Form.Control
              autoComplete="nope"
              required
              type="text"
              name="registration"
              onChange={e => props.handleCreateEmail(e)}
            />
          </Form.Group>
        </Col>
        <Col sm={8}>
          <Form.Group controlId="name">
            <Form.Label>*Nome:</Form.Label>
            <Form.Control
              autoComplete="nope"
              type="text"
              required
              name="name"
              onChange={e => props.handleCreateEmail(e)}
            />
          </Form.Group>
        </Col>
      </Row>


      <Row className="mt-4">
        <Col sm={8} style={{ paddingRight: 0 }}>
          <Form.Group controlId="email">
            <Form.Label>*e-mail sugerido:</Form.Label>
            <Form.Control
              autoComplete="nope"
              type="text"
              required
              name="email"
              onChange={e => props.handleCreateEmail(e)}
            />
          </Form.Group>
        </Col>
        <Col sm={4} style={{ paddingLeft: 0 }}>
          <Form.Group>
            <Form.Label>&nbsp;</Form.Label>
            <Form.Control
              autoComplete="nope"
              type="text"
              readOnly
              value="@fesaude.niteroi.rj.gov.br"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col sm={6}>
          <Form.Group controlId="phone">
            <Form.Label>*Telefone:</Form.Label>
            <Form.Control
              autoComplete="nope"
              type="text"
              required
              name="phone"
              onChange={e => props.handleCreateEmail(e)}
              placeholder="(21) 99999-9999"
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group controlId="admissionDate">
            <Form.Label>*Data de admissão:</Form.Label>
            <Form.Control
              autoComplete="nope"
              required
              type="date"
              name="admissionDate"
              onChange={e => props.handleCreateEmail(e)}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col sm={12}>
          <Form.Group controlId="unit">
            <Form.Label>*Unidade:</Form.Label>
            <Form.Select
              autoComplete="nope"
              className="border border-secondary"
              required
              name="unit"
              onChange={e => props.handleCreateEmail(e)}
              value={props.createEmail.unit}
            >
              <option value="" disabled>Selecione a Unidade</option>
              {props.unidades && props.unidades.map(item => (
                <option key={item.id} value={item.unidade}>{item.unidade}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col sm={12}>
          <Form.Group controlId="job">
            <Form.Label>*Cargo:</Form.Label>
            <Form.Control
              autoComplete="nope"
              required
              type="text"
              name="job"
              onChange={e => props.handleCreateEmail(e)}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col sm={12}>
          <Form.Group controlId="sisged">
            <Form.Label>*Criar usuário no SisGeD?</Form.Label>
            <Form.Select
              autoComplete="nope"
              className="border border-secondary"
              required
              name="sisged"
              onChange={e => props.handleCreateEmail(e)}
              value={props.createEmail.sisged}
            >
              <option value={true}>Sim</option>
              <option value={false}>Não</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Modal show={props.showEmailModal} onHide={props.closeEmailModal}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.emailError}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.closeEmailModal}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Email;
